import {
    DiscountAppliesTo,
    DiscountContract,
    DiscountMinimumRequirement,
} from 'models'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import {
    OrderFulfilmentType,
    OrderItemViewModel,
} from 'store/models/sellModels'
import { OrderChannel } from 'constant/OrderChannels'
import { checkAvailability } from 'utilities/availability/checkAvailability'
import { calculateLineSubtotal } from 'views/Sale/utils/orderCalculation/common'
dayjs.extend(isBetween)

export const isActiveDiscount = (discount: DiscountContract) =>
    discount.isActive ?? true

export const notInExcludeAutoDiscountIds = (
    discount: DiscountContract,
    excludeIds: string[] = [],
) => !excludeIds.includes(discount.discountID!!)

export const doesDiscountContainFulfillmentType = (
    discount: DiscountContract,
    fulfillmentId: OrderFulfilmentType,
) =>
    (discount.fulfillmentIDs?.includes(fulfillmentId) ?? true) ||
    discount.fulfillmentIDs?.length === 0

export const doesDiscountContainOrderChannel = (
    discount: DiscountContract,
    orderChannel: OrderChannel,
): boolean =>
    (discount.orderChannelIDs?.includes(orderChannel) ?? true) ||
    discount.orderChannelIDs?.length === 0

export const isTimeEventDiscountAvailable = (
    discount: DiscountContract,
    dateCompare: string = new Date().toISOString(),
) => {
    if (discount.isTimedEventDiscount) {
        const discountAvailability = discount.discountAvailabilities![0]
        return checkAvailability(discountAvailability, dateCompare)
    }

    return true
}

export const appliesToCompareByItemFilterDiscount = (
    item: OrderItemViewModel,
    discount: DiscountContract,
): boolean => {
    const { appliesTo, applyToIDs } = discount

    if (appliesTo === DiscountAppliesTo.SelectedProducts)
        return (
            (applyToIDs?.includes(item.item.itemId) ||
                applyToIDs?.includes(item.item.baseItemId ?? '')) ??
            false
        )
    else if (appliesTo === DiscountAppliesTo.SelectedCategories)
        return applyToIDs?.includes(item.item.categoryId) ?? false

    return true
}

export const itemMinReqFilterDiscount = (
    item: OrderItemViewModel,
    discount: DiscountContract,
): boolean => {
    const { minRequirement, minRequirementValue } = discount
    const lineTotal = calculateLineSubtotal(item)

    if (minRequirement === DiscountMinimumRequirement.MinimumPurchaseAmount) {
        return lineTotal.greaterThanOrEqualTo(minRequirementValue!!)
    }

    if (minRequirement === DiscountMinimumRequirement.MinimumQuantityOfItems) {
        return item.amount >= minRequirementValue!!
    }

    return true
}
